import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function fetchMetalPrices() {
  const { data } = await api.get("/metals/prices");
  return data;
}

export async function calculateQuote(payload) {
  const { data } = await api.post("/calculate", payload);
  return data;
}
